<template>
  <div class="SupplyChain">
    <BannerVideo :video-url="$StaticFileUrl + '/mp/video/supplychainVideo.mp4'">
      <div class="title wow fadeInDown" data-wow-duration="1s">全链聚合，一体化服务</div>
      <div class="desc wow fadeInDown" data-wow-duration="1s">为有多品类商品采购需求的企业自有平台提供全品类、商品、<br>仓储、配送、售后一体化供应链综合服务</div>
      <div class="flex-row flex-col-center">
        <div class="btn-red wow flipInX" data-wow-duration="1s" style="margin-top: 100px">立即体验</div>
      </div>
    </BannerVideo>
  </div>
</template>

<script>
import WOW from 'wowjs'
import BannerVideo from '@/components/BannerVideo'

/**
 * @author  XuHongli
 * @date  2022/12/28 10:12
 * @version 1.0
 * @description
 */
export default {
  name: 'SupplyChain',
  components: {BannerVideo},
  mounted() {
    new WOW.WOW().init()
  }
}
</script>

<style scoped>

</style>
